import { render, staticRenderFns } from "./CloseTicketModal.vue?vue&type=template&id=39027fe9&"
import script from "./CloseTicketModal.vue?vue&type=script&lang=js&"
export * from "./CloseTicketModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports